module.exports = __webpack_public_path__ + "static/img/12.1.1a44988.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/12.1.png
// module id = MdYa
// module chunks = 0